/**
 * Menu
 */
export default {
    m: {
        Home: '首页',
        Dashboard: '数据看板',
        Users: '用户管理',
        Users_Users: '用户管理',
        'Users_Registration-Channels': '注册渠道',
        Users_Overview: '用户概览',
        Dashboard_Features_Overview: '功能概览',

        'Financial-Management': '财务管理',
        'Financial-Management_Capital-Operation-Records': '资金操作记录',

        'System-Management': '系统管理',
        'System-Management_Accounts': '账号管理',
        'System-Management_Roles': '角色管理',
        'System-Management_System-Logs': '系统日志',
        'System-Management_Exports': '下载管理',

        'Service-Config_Service-Config': '服务配置',

        'Client-Management': '客户端配置',
        'Client-Management_App-Version-Updates': 'App 版本配置',
        'Client-Management_Content-Filter': '版本内容过滤',
        'Client-Management_Banner': 'Banner 配置',

        Dramas: '剧集管理',
        Dramas_Dramas: '短剧列表',
        Dramas_Reports: '举报',
        Dramas_Reports_Content: '内容举报记录',
        Dramas_Reports_Users: '用户举报记录',
        Dramas_Reports_Comments: '评论举报记录',
        Dramas_Comments: '评论列表',
        'Dramas_Mining-Weekly-Rewards': '挖矿结算管理',
        'Dramas_Activity-1011': '1011活动管理',
        'Dramas_Activity-1011_Share-Review': '分享审核',
        'Dramas_Activity-1011_User-Stories': '故事收集',
        'Dramas_Activity-1011_Task-Config': '任务配置',
    },
};
